"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UptimeBar = () => {
  const width = '8px';
  const height = width;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: '3px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex",
    style: {
      gap: '3px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-gray-light",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-gray-light",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-green",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-green",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-green",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-green",
    style: {
      width,
      height
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "br-1px bg-green",
    style: {
      width,
      height
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "font-size-12px font-mono font-weight-400 text-align-right color-text-green",
    style: {
      lineHeight: '12px',
      paddingTop: '3px'
    }
  }, "100.000%"));
};
var _default = exports.default = UptimeBar;